<template lang="slm">
  .album
    .img-container
      .img :style='"background-image:url(/api/file/" + imageId + ")"'
    h3.mt-4.mb-0.font-weight-semi-bold {{ title }}
    span.font-weight-light {{ artist }} – {{ year }}
</template>

<style lang="stylus" scoped>
.album
  display inline-block
  color black
  text-align left
  max-width 100%
  .img-container
    position relative
    width 350px
    max-width 100%
    .img
      position absolute
      top 0
      left 0
      width 100%
      height 100%
      box-shadow 7px 10px 40px -5px rgba(0, 0, 0, 0.3)
      background-repeat no-repeat
      background-size cover
    &:before
      content ''
      padding-top 100%
      width 100%
      display block
  *
    display block
  h3
  span
    text-shadow 0 0 10px rgba(128,128,128,0.5)
</style>

<script>
export default {
  name: 'MusicAlbum',
  props: {
    imageId: {
      type: Number,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    artist: {
      type: String,
      required: true,
    },
    year: {
      type: [String, Number],
      required: true,
    },
  },
};
</script>
